import $ from 'jquery';

const setOverFlowClass = () => {
    const el = $('.js-rate-container');

    if (el.length === 0) {
        return;
    }

    const hasOverFlow = el[0].clientWidth < el[0].scrollWidth;

    $('.exchange-rate-block__table-container').toggleClass(
        'exchange-rate-block__table-container--overflowing',
        hasOverFlow
    );
};

export default function() {
    setOverFlowClass();

    $(window).resize(setOverFlowClass);
}
